import { render } from "./AiInterpModal.vue?vue&type=template&id=16f2bdfd&scoped=true&ts=true"
import script from "./AiInterpModal.vue?vue&type=script&lang=ts"
export * from "./AiInterpModal.vue?vue&type=script&lang=ts"

import "./AiInterpModal.vue?vue&type=style&index=0&id=16f2bdfd&lang=less&scoped=true"
import "./AiInterpModal.vue?vue&type=style&index=1&id=16f2bdfd&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f2bdfd"]])

export default __exports__